module.exports = __webpack_public_path__ + "static/media/038-man-10.8446458d.svg";